import React from "react";
import Button from '@material-ui/core/Button';
import { useTranslate } from "ra-core";
import { downloadResource } from "../../services/file-explorer/fileExplorerApi";

const DownloadButton = (props) => {
    const { url } = props;
    const translate = useTranslate();

    const handleOnClickDownload = () => {
        downloadResource(url);
    }

    return (
        <Button variant={'outlined'} color={'secondary'} onClick={handleOnClickDownload}>{translate(`cmss.resources.file.download`)}</Button>
    );
}

export default DownloadButton;